import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { MascotPanel } from '../ui/MascotPanel';
import { launchDateOptions } from '../../data/intakeOptions';
import { toOptions } from '../../utils/options';
const reveal = {
  initial: {
    opacity: 0,
    height: 0
  },
  animate: {
    opacity: 1,
    height: 'auto'
  },
  exit: {
    opacity: 0,
    height: 0
  },
  transition: {
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }
};
export function Step14Planning() {
  const {
    data,
    updateData
  } = useIntake();
  const askDeadline = data.launchDate !== '' && data.launchDate !== 'relaxed';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-201" data-mp="11vgzpi2hsu1y">
      <MascotPanel message="De laatste stap voor de afronding! Laten we de planning en verwachtingen afstemmen." data-id="element-202" data-mp="2d81hp9ugitb1" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-203" data-mp="lg3wqj2evevq">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-204" data-mp="qf744a5v5x6v">
          Planning & Workflow
        </h2>

        <div data-id="element-205" data-mp="va4a187ujqfj">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-206" data-mp="vackktghyjnk">
            Wanneer wilt u de website idealiter live hebben?
          </label>
          <RadioGroup columns={2} value={data.launchDate} onChange={val => updateData({
          launchDate: val
        })} options={toOptions(launchDateOptions)} data-id="element-207" data-mp="2oukw3564e0z" />

          <AnimatePresence data-id="element-208" data-mp="ck4sd6ec5dm5">
            {askDeadline && <motion.div key="deadline" {...reveal} className="overflow-hidden" data-id="element-209" data-mp="hcxqvcj7npps">
                <div className="pt-6 space-y-4" data-id="element-210" data-mp="3g2o7d7806mz0">
                  <div data-id="element-211" data-mp="3g1wmorfy29ni">
                    <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-212" data-mp="3g0lkux627bz1">
                      Is dit een harde deadline?
                    </label>
                    <RadioGroup columns={2} value={data.hardDeadline} onChange={val => updateData({
                  hardDeadline: val
                })} options={[{
                  value: 'yes',
                  label: 'Ja'
                }, {
                  value: 'no',
                  label: 'Nee'
                }]} data-id="element-213" data-mp="3czieay5he2ch" />
                  </div>
                  <AnimatePresence data-id="element-214" data-mp="2u2qr4dmtj335">
                    {data.hardDeadline === 'yes' && <motion.div key="deadline-reason" {...reveal} className="overflow-hidden" data-id="element-215" data-mp="2p45xix22nhno">
                        <Input label="Waarom? (bijv. beurs, opening, campagne)" placeholder="Bijv. opening nieuwe vestiging op 1 maart" value={data.deadlineReason} onChange={e => updateData({
                    deadlineReason: e.target.value
                  })} data-id="element-216" data-mp="340wp4k5i7p2q" />
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        <Input label="Wie geven er feedback op het ontwerp?" placeholder="Bijv. alleen ik, of ik + mijn compagnon" value={data.feedbackGivers} onChange={e => updateData({
        feedbackGivers: e.target.value
      })} data-id="element-217" data-mp="cuyzxzevbewl" />

        <Textarea label="Heeft u nog vragen of opmerkingen voor Noord Digital?" placeholder="Bijv. vragen over de werkwijze, kosten of planning..." value={data.remarks} onChange={e => updateData({
        remarks: e.target.value
      })} data-id="element-218" data-mp="19jn3xrtr11n0" />

        <div className="pt-6 border-t border-gray-100" data-id="element-219" data-mp="zrqwvr9oq16n">
          <Textarea label="Extra notities voor het ontwikkelteam" placeholder="Heeft u nog specifieke wensen, technische eisen, of andere informatie die belangrijk is voor het bouwen van uw website? Alles wat u hier schrijft wordt meegenomen in het ontwikkelproces." value={data.extraNotes} onChange={e => updateData({
          extraNotes: e.target.value
        })} className="min-h-[160px]" data-id="element-220" data-mp="1niwby47swpfw" />
        </div>
      </div>
    </motion.div>;
}